import "./About.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import SpecializedServices from "./sections/SpecializedServices";
import TrustedBrands from "./sections/TrustedBrands";
import GetInTouch from "./sections/GetInTouch";
import CorporateInformationFooter from "@/reusable_sections/Footer";
import Meetourexperts from "./sections/Meetourexperts";
export default function AboutPage() {
  return <div>
      <MainNavigationHeader />
      <Overview />
      <Meetourexperts />
      <SpecializedServices />
      <TrustedBrands />
      <GetInTouch />
      <CorporateInformationFooter />
    </div>;
}